import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  width: 50%;
  @media screen and ${Device.tablet} {
    width: 75%;
  }
  @media screen and ${Device.mobileL} {
    width: 100%;
  }
  .site-block {
    p {
      margin-bottom: 2em;
    }
  }
  .btn {
    display: block;
    margin: 0 auto;
  }
`;
